import TanksInput from './TanksInput';

export default TanksInput;
